import { render, staticRenderFns } from "./receivables.vue?vue&type=template&id=26cb6d8b&scoped=true&"
import script from "./receivables.vue?vue&type=script&lang=js&"
export * from "./receivables.vue?vue&type=script&lang=js&"
import style0 from "./receivables.vue?vue&type=style&index=0&id=26cb6d8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cb6d8b",
  null
  
)

export default component.exports